import { render, staticRenderFns } from "./bindEmail.vue?vue&type=template&id=22282272"
import script from "./bindEmail.vue?vue&type=script&lang=js"
export * from "./bindEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports